/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import classNames from 'classnames';
import { SubMenu as RcSubMenu } from './rc-menu';
import MenuContext from './MenuContext';
import { isValidElement, cloneElement } from '../_util/reactNode';
import { MenuContext as BaseMenuContext } from './rc-menu/context/MenuContext';
const SubMenu = props => {
    var _a;
    const { popupClassName, title, icon } = props, rest = __rest(props, ["popupClassName", "title", "icon"]);
    const contextValue = useContext(MenuContext);
    const baseMenuContextValue = useContext(BaseMenuContext);
    const { inlineCollapsed } = baseMenuContextValue;
    const { menuMode, prefixCls, firstLevel } = contextValue;
    let titleNode;
    if (!icon) {
        titleNode = <span className={`${prefixCls}-title-content`}>{(inlineCollapsed && firstLevel && typeof title === 'string')
                ? title.charAt(0)
                : <span className={`${prefixCls}-title-content-inner`}>{title}</span>}</span>;
    }
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        const titleIsSpan = isValidElement(title) && title.type === 'span';
        titleNode = (<>
                {cloneElement(icon, {
                className: classNames(isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', `${prefixCls}-item-icon`)
            })}
                {titleIsSpan ? title : <span className={`${prefixCls}-title-content`}>
                    <span className={`${prefixCls}-title-content-inner`}>{title}</span>
                </span>}
            </>);
    }
    return (<MenuContext.Provider value={Object.assign(Object.assign({}, contextValue), { firstLevel: false })}>
            <RcSubMenu popupClassName={classNames(`${prefixCls}-${menuMode}-mode`, popupClassName)} className={classNames({
            [`${prefixCls}-submenu-with-icon`]: icon
        })} title={titleNode} preTitle={title} {...rest}/>
        </MenuContext.Provider>);
};
export default SubMenu;
